import React, { useState, useEffect, useRef, forwardRef } from 'react';

const Scroll = forwardRef((props, ref) => {
  const { visible = false, children, fetchMoreData, scrollTrigger, scrollTopTrigger = false, scrolling = false, setScrolling = () => { }, height } = props;
  const [isFetching, setIsFetching] = useState(false);
  // const [isFetchingUp, setIsFetchingUp] = useState(false);
  // const ref = useRef(null);
  const innerRef = useRef(); 
  const [last, setLast] = useState(0);
  const buffer = 1000;



  useEffect(() => {
    const handleScroll = () => {
      const { scrollTop, scrollHeight } = ref.current;


      if (scrollTop <= -250 && !scrolling) {
        setScrolling(true);
      }

      if (scrollTop >= -101 && scrolling) {
        setScrolling(false);
      }

      const diff = scrollHeight - (window.innerHeight - 118);
      const invert = diff + scrollTop;

      // Direction
      const isUp = (invert < last);
      setLast(invert);

      if (invert < buffer && isUp && !isFetching) {
        setIsFetching(true);
      }

      // if (scrollTop > -buffer && isUp && !isFetching) {
      //   setIsFetchingUp(true);
      // }
    };

    const scrollableContainer = ref.current;
    scrollableContainer.addEventListener('scroll', handleScroll);

    return () => scrollableContainer.removeEventListener('scroll', handleScroll);
  }, [last]);


  useEffect(() => {
    if (!isFetching) return;
    fetchMoreData().then(() => {
      setIsFetching(false);
    }).catch((error) => {
      setIsFetching(false);
    });

    // clearTimeout(if_timout);
    // if_timout = setTimeout(() => {
    //   if(isFetching){

    //     setIsFetching(false);
    //   }
    // }, 2000)

  }, [isFetching]);

  // useEffect(() => {
  //   if (!isFetchingUp) return;
  //   fetchMoreData(true).then(() => {
  //     setIsFetchingUp(false);
  //   }).catch(() => {
  //     setIsFetchingUp(false);
  //   });
  // }, [isFetchingUp]);


  useEffect(() => {

    if (scrollTopTrigger) {
      ref.current.scrollTop = -(ref.current.scrollHeight - (window.innerHeight - 250))
    }

  }, [scrollTopTrigger, ref])






  useEffect(() => {
    if (!visible) {
      ref.current.scrollTop = 0;
      setTimeout(() => {
        ref.current.scrollTop = 0;
      }, 10)
    }
  }, [visible, scrollTrigger])

  return (
    <>
      <div style={{ "position": "fixed", "zIndex": "99999", "width" : "100%" }} className='float-flex'>
        <div style={{"backgroundColor" : "#f00"}}>
          {isFetching && <div style={{ "textAlign": "center", "padding": "2px 0px", "position" : "absolute", "backgroundColor" : "#00000088", "width" : "100%" }}>Loading...</div>}
          {/* {isFetchingUp && <div style={{ "textAlign": "center", "padding": "20px" }}>Loading Below...</div>} */}
        </div>
      </div>
      <div className="heightAni" ref={ref} style={{ overflowY: 'auto', height: height - 20 + "px", "display": "flex", "flexDirection": "column-reverse" }}>
        <div ref={innerRef}>
          {children}
        </div>
      </div>
    </>
  );
});

export default Scroll;